var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBhansaLogoNotext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 111.04 101.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0b6fae;}.cls-2{fill:#fab10b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bhansa-logo-notext") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.82,101.77,56.29.17l55.57,101.54-45-13.18-10.4-6.38-11,6.62Z",
    transform: "translate(-0.82 -0.17)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.62,25.24a91.31,91.31,0,0,0-50.27,15l5.51,6.82a83,83,0,0,1,89-.36l5.5-6.82a91.3,91.3,0,0,0-49.7-14.64m0,17.09A74.26,74.26,0,0,0,17.15,53.62l6,7.48a65.12,65.12,0,0,1,66.3-.34l6-7.5A74.32,74.32,0,0,0,56.62,42.33m0,17.87a56.57,56.57,0,0,0-28.14,7.47l5.72,7.09a47.88,47.88,0,0,1,44.23-.31l5.75-7.12A56.52,56.52,0,0,0,56.62,60.2m0,17.08A39.61,39.61,0,0,0,39.39,81.2l6.13,7.53a30.55,30.55,0,0,1,21.53-.16l6.17-7.65a39.52,39.52,0,0,0-16.6-3.64m0,16.7a22.67,22.67,0,0,0-6.21.88L56.17,102h0l5.91-7.32a22.79,22.79,0,0,0-5.51-.7",
    transform: "translate(-0.82 -0.17)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBhansaLogoNotext);
export default __webpack_public_path__ + "static/media/bhansa-logo-notext.d3437ef0177d46c1cac74a1013030704.svg";
export { ForwardRef as ReactComponent };